var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8018 11.0379L22.1488 11.0379L16.9796 3.29598C16.8692 3.13966 16.7222 3.01275 16.5515 2.92634C16.3807 2.83994 16.1914 2.79666 16.0001 2.8003C15.8074 2.79629 15.6168 2.84064 15.4457 2.92929C15.2745 3.01794 15.1284 3.14807 15.0205 3.30778L9.85135 11.0379L4.1983 11.0379C3.8853 11.0379 3.58512 11.1623 3.36379 11.3836C3.14247 11.6049 3.01813 11.9051 3.01813 12.2181C3.01643 12.3262 3.03237 12.4338 3.06533 12.5368L6.06298 23.477C6.19976 23.9728 6.49558 24.4099 6.90496 24.7212C7.31434 25.0325 7.81462 25.2007 8.32892 25.2L23.6712 25.2001C24.1865 25.1992 24.6875 25.0306 25.0985 24.7197C25.5094 24.4088 25.808 23.9726 25.949 23.477L28.9466 12.5368L28.982 12.2181C28.982 11.9051 28.8577 11.6049 28.6363 11.3836C28.415 11.1623 28.1148 11.0379 27.8018 11.0379ZM16.0001 6.08119L19.3046 11.0379L12.6956 11.0379L16.0001 6.08119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.6048def29e708748e3b2a7677ceab33f.svg";
export { ForwardRef as ReactComponent };